import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { toast } from '@getpingback/realeza';
import { PlusIcon, TrashCanIcon } from '@stash-ui/regular-icons';
import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';
import DeleteModal from '../EducationCourse/components/DeleteModal';

import { getCourses, deleteCourse } from '../../services/education';

const EducationList = () => {
  const history = useHistory();

  const [courses, setCourses] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [searchField, setSearchField] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState({
    isOpen: false,
    courseId: null,
  });

  useEffect(() => {
    getCoursesData();
  }, []);

  const formatedCourses = courses.map(course => ({
    uid: course.id,
    ...course,
  }));

  const headers = ['id', 'name', 'createdAt', 'category'];

  const getCoursesData = async (page, searchField) => {
    try {
      const { data: courses } = await getCourses(page, searchField);
      setCourses(courses.rows);
      setPage(courses.page);
      setTotalPages(courses.totalPages);
      setTotalCount(courses.count);
    } catch (error) {
      throw error;
    }
  };

  const handleSubmitSearch = searchBox => {
    setSearchField(searchBox.search);
    getCoursesData(0, searchBox.search);
  };

  const handlePageChange = page => {
    setPage(page);
    getCoursesData(page, searchField);
  };

  const handleDeleteCourse = async courseId => {
    try {
      await deleteCourse(courseId);
      setDeleteModalOpen({
        isOpen: false,
        courseId: null,
      });
      getCoursesData();
      toast.success('Course deleted successfully');
    } catch (error) {
      console.error(error);
      toast.error(`Error: ${error?.response?.data?.error?.message}`);
    }
  };

  const customActions = [
    {
      icon: <TrashCanIcon color="#f96e6eb2" />,
      action: item => {
        setDeleteModalOpen({
          isOpen: true,
          courseId: item.id,
        });
      },
    },
  ];

  return (
    <div className="education">
      <div className="education__header">
        <h1>Education courses ({totalCount})</h1>
        <div className="education__header__right">
          <Button variant="contained" startIcon={<PlusIcon />} onClick={() => history.push('/education/course/')}>
            Add Course
          </Button>
          <SearchBox selectItems={['name']} onSubmitSearch={handleSubmitSearch} />
        </div>
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={formatedCourses}
        customActions={customActions}
        bodyColumn={headers}
        linkPath={'education/course'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={handlePageChange}
      />

      <DeleteModal
        isOpen={deleteModalOpen.isOpen}
        onClose={() => setDeleteModalOpen({ isOpen: false, courseId: null })}
        onDelete={() => handleDeleteCourse(deleteModalOpen.courseId)}
        message="Are you sure you want to delete this course? This action will delete all the modules and lessons associated with this course."
        title="Delete Course"
      />
    </div>
  );
};

export default EducationList;
